import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import ResponsiblesFactorsServices from "./ResponsiblesFactors.services"

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getResponsibleFactor = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_RESPONSIBLEFACTOR,
      payload: true,
    });
    const resp = await ResponsiblesFactorsServices.getResponsibleFactor(filters);
    console.log()
    dispatch({
      type: actions.GET_RESPONSIBLEFACTOR,
      payload: {
        responsiblesFactors: resp.data.data,
        responsiblesFactorsLength: resp.data.count
      },

    });
    dispatch({
      type: actions.RESPONSIBLEFACTOR_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.RESPONSIBLEFACTOR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_RESPONSIBLEFACTOR,
      payload: false,
    });
  }


};     
             

export const getOrganizationalUnits = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_ORGANIZATIONALUNIT,
      payload: true,
    });
    const resp = await ResponsiblesFactorsServices.getOrganizationalUnits(filters);
    dispatch({
      type: actions.GET_ORGANIZATIONALUNIT,
      payload: {
        organizationalUnits: resp.data.data,
        organizationalUnitsLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.ORGANIZATIONALUNIT_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.ORGANIZATIONALUNIT_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_ORGANIZATIONALUNIT,
      payload: false,
    });
  }
};


export const getFactorsCriteria = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_FACTORCRITERION,
      payload: true,
    });
    const resp = await ResponsiblesFactorsServices.getFactorsCriteria(filters);
    dispatch({
      type: actions.GET_FACTORCRITERION,
      payload: {
        factorsCriteria: resp.data.data,
        factorsCriteriaLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.FACTORCRITERION_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FACTORCRITERION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FACTORCRITERION,
      payload: false,
    });
  }
}


export const saveResponsibleFactor =
  (data, setShowModal) => async (dispatch, getState) => {
    try {

      dispatch({
        type: actions.SAVE_LOADING_RESPONSIBLEFACTOR,
        payload: true,
      });
      const resp = await ResponsiblesFactorsServices.saveResponsibleFactor(data);
      console.log("nuevo ", resp.data)
      
      const { responsiblesFactors, responsiblesFactorsLength } = getState().responsibleFactor;
      const _responsiblesFactors = [...responsiblesFactors, resp.data[0]];
      console.log("devuelve",_responsiblesFactors)
      dispatch({
        type: actions.GET_RESPONSIBLEFACTOR,
        payload: {
          responsiblesFactors: _responsiblesFactors,
          responsiblesFactorsLength: responsiblesFactorsLength + 1,

        },


      });

      dispatch({
        type: actions.FORM_FAIL,
        payload: "",

      })
      setShowModal(false);
      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_RESPONSIBLEFACTOR,
        payload: false,
      });
    }
  };

export const editResponsibleFactor =
  (data, id, index, setShowModal) => async (dispatch, getState) => {
    try {

      dispatch({
        type: actions.LOADING_RESPONSIBLEFACTOR,
        payload: true,
      });
      const resp = await ResponsiblesFactorsServices.editResponsibleFactor(id, data);

      const { responsiblesFactors, responsiblesFactorsLength } = getState().responsibleFactor;
      responsiblesFactors[index] = resp.data;
      dispatch({
        type: actions.GET_RESPONSIBLEFACTOR,
        payload: {
          responsiblesFactors: responsiblesFactors,
          responsiblesFactorsLength: responsiblesFactorsLength        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);

      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_RESPONSIBLEFACTOR,
        payload: false,
      });
    }
  };

export const deleteResponsibleFactor = (id, index) => async (dispatch, getState) => {
  try {

    dispatch({
      type: actions.LOADING_RESPONSIBLEFACTOR,
      payload: true,
    });
    await ResponsiblesFactorsServices.deleteResponsibleFactor(id);
    debugger
     const { responsiblesFactors, responsiblesFactorsLength } = getState().responsibleFactor;
     responsiblesFactors.splice(index, 1);

    dispatch({
      type: actions.GET_RESPONSIBLEFACTOR,
      payload: {
        responsiblesFactors: responsiblesFactors,
        responsiblesFactorsLength: responsiblesFactorsLength - 1      },
    });
    dispatch({
      type: actions.RESPONSIBLEFACTOR_FAIL,
      payload: "",
    });

    toastr.success(messages.successMessage, " ", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }

    dispatch({
      type: actions.RESPONSIBLEFACTOR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_RESPONSIBLEFACTOR,
      payload: false,
    });
  }
};
